export default __webpack_public_path__ + "static/media/vf-associate-as-child.4e5aa224.svg";